/**
 * Shared active-ask correlation predicate for Deep ask_user HITL.
 *
 * Render gating (AskUserRenderer) and page-level dispatch (ai-explorer-page)
 * must agree: only a proposed prompt whose ask_id matches the artifact may
 * accept respond/skip. Keeping one helper prevents the mirror/tests drift
 * that previously green-lit clearing pending state before a successful send.
 */
export function isActiveAskUserPrompt(args: {
  askUserProposed: boolean
  pendingAskId?: string | null
  artifactAskId?: string | null
}): boolean {
  const { askUserProposed, pendingAskId, artifactAskId } = args
  return (
    askUserProposed &&
    typeof artifactAskId === "string" &&
    artifactAskId.trim().length > 0 &&
    typeof pendingAskId === "string" &&
    pendingAskId.trim().length > 0 &&
    artifactAskId === pendingAskId
  )
}
